import React, { useState, useEffect, useCallback } from "react";
import "./Header.css";
// import { Link } from 'react-router-dom';
import { MdNotifications } from "react-icons/md";
import { TiArrowSortedDown } from "react-icons/ti";
import {
  Menu,
  MenuItem,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";
import ProfilePage from "./ProfilePage";
import { get, post, put, del } from "../../utility/fetchWeb";
import {
  get as gets,
  post as posts,
  put as puts,
  del as dels,
} from "../../utility/fetch2";

import UserAvater from "../../assets/images/user-avater.png";
// import HeaderSearch from "../inputs/HeaderSearch";

// import { formatFileUrl } from "../../utility/general";

const Header = ({ history, details = {}, navList = [] }) => {
  const [userPix, setUserPix] = useState("");
  const [imgHasError, setImgHasError] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [notificationCount, setNotificationCount] = useState(0);
  const userInfo = JSON.parse(localStorage.getItem("USER_INFO"));

  const [showProfile, setShowProfile] = useState(false);
  const [notificationMenuAnchor, setNotificationMenuAnchor] = useState(null);
  const [showReminderModal, setShowReminderModal] = useState(false);
  const [showRemindersList, setShowRemindersList] = useState(false);
  const [showReminderPopup, setShowReminderPopup] = useState(false);
  const [activeReminder, setActiveReminder] = useState(null);
  const [reminders, setReminders] = useState([]);
  const [editingReminder, setEditingReminder] = useState(null);
  const [reminderData, setReminderData] = useState({
    message: "",
    date: "",
    time: "",
    isRead: false,
    userId: 0,
    userType: "doctor",
  });

  const handleProfileOpen = () => setShowProfile(true);
  const handleProfileClose = () => setShowProfile(false);

  const handleNotificationClick = (event) => {
    setNotificationMenuAnchor(event.currentTarget);
  };

  const handleNotificationClose = () => {
    setNotificationMenuAnchor(null);
  };

  // Mark notification as read
  const markNotificationAsRead = async (notificationId) => {
    try {
      const response = await put(`/Notifications/markasread/${notificationId}`);
      console.log("Notification marked as read:", response);

      // Update local state
      setNotifications((prev) =>
        prev.map((notification) =>
          notification.id === notificationId
            ? { ...notification, isRead: true }
            : notification
        )
      );

      // Update notification count
      setNotificationCount((prev) => Math.max(0, prev - 1));
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  };

  const handleNotificationItemClick = (notification) => {
    // Mark as read if not already read
    if (!notification.isRead) {
      markNotificationAsRead(notification.id);
    }

    // Close the menu
    handleNotificationClose();

    // Reroute to Connect Health Pro
    window.open("https://practitioners.connecthealthpro.com/login", "_blank");
  };

  const handleNavItemClick = (item) => {
    if (item.toLowerCase() === "set reminder") {
      setShowRemindersList(true);
    }
  };

  const handleCreateNewReminder = () => {
    setEditingReminder(null);
    setReminderData({
      message: "",
      date: "",
      time: "",
      isRead: false,
      userId: 0,
      userType: "doctor",
    });
    setShowRemindersList(false);
    setShowReminderModal(true);
  };

  const handleRemindersListClose = () => {
    setShowRemindersList(false);
  };

  const handleReminderClose = () => {
    setShowReminderModal(false);
    setShowRemindersList(true);
    setShowReminderModal(false);
    setEditingReminder(null);
    setReminderData({
      message: "",
      date: "",
      time: "",
      isRead: false,
      userId: 0,
      userType: "doctor",
    });
  };

  // CRUD Operations for Reminders

  // Create or Update Reminder
  const handleReminderSubmit = async () => {
    try {
      const payload = {
        message: reminderData.message,
        date: new Date(
          `${reminderData.date}T${reminderData.time}:00.000Z`
        ).toISOString(),
        time: reminderData.time,
        isRead: reminderData.isRead,
        userId: userInfo.userId,
        userType: reminderData.userType,
      };

      let response;
      if (editingReminder) {
        // Update existing reminder
        response = await puts(`/reminder/${editingReminder.id}`, payload);
        console.log("Reminder updated:", response);
        handleReminderClose();
        // Check for successful status codes
        if (response.status && [200, 201, 202, 204].includes(response.status)) {
          // alert("Reminder updated successfully!");
          handleReminderClose();
        } else {
          handleReminderClose();

          throw new Error("Unexpected response status");
        }
      } else {
        // Create new reminder
        response = await posts("/reminder", payload);
        console.log("Reminder created:", response);
        handleReminderClose();
        // Check for successful status codes
        if (response.status && [200, 201, 202, 204].includes(response.status)) {
          // alert("Reminder created successfully!");
          handleReminderClose();
        } else {
          handleReminderClose();

          throw new Error("Unexpected response status");
        }
      }

      // Close modal and reset form
      handleReminderClose();

      // Refresh reminders list
      fetchReminders();

      // Show the reminders list again
      setShowRemindersList(true);
    } catch (error) {
      console.error("Error saving reminder:", error);
      // alert("Failed to save reminder. Please try again.");
    }
  };

  // Fetch all reminders for user
  const fetchReminders = useCallback(async () => {
    try {
      const response = await gets(`/reminder/user/${userInfo.userId}`);
      console.log("Reminders:", response);
      handleReminderClose();

      if (response && response?.items) {
        setReminders(response?.items || []);
      }
    } catch (error) {
      handleReminderClose();

      console.error("Error fetching reminders:", error);
    }
  }, [userInfo.userId]);

  // Delete reminder
  const deleteReminder = async (reminderId) => {
    try {
      const response = await dels(`/reminder/${reminderId}`);
      console.log("Reminder deleted:", response);
      handleReminderClose();

      // Check for successful status codes
      if (response.status && [200, 201, 202, 204].includes(response.status)) {
        // alert("Reminder deleted successfully!");
        handleReminderClose();
      } else {
        handleReminderClose();

        throw new Error("Unexpected response status");
      }

      // Refresh reminders list
      fetchReminders();
      handleReminderClose();
    } catch (error) {
      console.error("Error deleting reminder:", error);
      handleReminderClose();
      fetchReminders();

      // alert("Failed to delete reminder. Please try again.");
    }
    await fetchReminders();
  };

  // Mark reminder as read/completed
  const markReminderAsRead = async (reminderId) => {
    try {
      // Find the current reminder to get its current data
      const currentReminder = reminders.find((r) => r.id === reminderId);
      if (!currentReminder) {
        throw new Error("Reminder not found");
      }

      // Prepare payload for update with isRead set to true
      const payload = {
        message: currentReminder.message,
        date: currentReminder.date,
        time: currentReminder.time,
        isRead: true, // Mark as read
        userId: currentReminder.userId,
        userType: currentReminder.userType,
      };

      const response = await puts(`/reminder/${reminderId}`, payload);
      console.log("Reminder marked as read:", response);

      // Check for successful status codes
      if (response.status && [200, 201, 202, 204].includes(response.status)) {
        // alert("Reminder marked as completed successfully!");
        handleReminderClose();
        fetchReminders();
      } else {
        handleReminderClose();
        fetchReminders();

        throw new Error("Unexpected response status");
      }

      // Refresh reminders list
      fetchReminders();
      handleReminderClose();
    } catch (error) {
      console.error("Error marking reminder as read:", error);
      handleReminderClose();
      fetchReminders();

      // alert("Failed to mark reminder as read. Please try again.");
    }
    await fetchReminders();
  };

  // Snooze reminder (add 10 minutes to current time)
  const snoozeReminder = async (reminderId, snoozeMinutes = 10) => {
    try {
      // Find the current reminder to get its current data
      const currentReminder = reminders.find((r) => r.id === reminderId);
      if (!currentReminder) {
        throw new Error("Reminder not found");
      }

      // Calculate new time by adding snooze minutes to current time
      const now = new Date();
      const snoozeTime = new Date(now.getTime() + snoozeMinutes * 60 * 1000);

      // Format the new date and time
      const newDate = snoozeTime.toISOString().split("T")[0]; // YYYY-MM-DD
      const newTime = snoozeTime.toTimeString().slice(0, 5); // HH:MM

      // Prepare payload for update with new snooze time
      const payload = {
        message: currentReminder.message,
        date: new Date(`${newDate}T${newTime}:00.000Z`).toISOString(),
        time: newTime,
        isRead: currentReminder.isRead, // Keep current read status
        userId: currentReminder.userId,
        userType: currentReminder.userType,
      };

      const response = await puts(`/reminder/${reminderId}`, payload);
      console.log("Reminder snoozed:", response);

      // Check for successful status codes
      if (response.status && [200, 201, 202, 204].includes(response.status)) {
        // alert(`Reminder snoozed for ${snoozeMinutes} minutes successfully!`);
      } else {
        handleReminderClose();
        fetchReminders();

        throw new Error("Unexpected response status");
      }

      // Refresh reminders list
      fetchReminders();
      handleReminderClose();
    } catch (error) {
      console.error("Error snoozing reminder:", error);
      // alert("Failed to snooze reminder. Please try again.");
    }
    await fetchReminders();
  };

  // End/dismiss reminder
  const endReminder = async (reminderId) => {
    try {
      const response = await puts(`/reminder/${reminderId}/end`, {
        isActive: false,
        isRead: true,
      });
      console.log("Reminder ended:", response);

      // Check for successful status codes
      if (response.status && [200, 201, 202, 204].includes(response.status)) {
        // alert("Reminder ended successfully!");
      } else {
        throw new Error("Unexpected response status");
      }

      // Refresh reminders list
      fetchReminders();
    } catch (error) {
      console.error("Error ending reminder:", error);
      await fetchReminders();
      // alert("Failed to end reminder. Please try again.");
    }
  };

  // Edit reminder
  const editReminder = (reminder) => {
    setEditingReminder(reminder);
    const reminderDate = new Date(reminder.date);
    setReminderData({
      message: reminder.message,
      date: reminderDate.toISOString().split("T")[0],
      time: reminderDate.toTimeString().slice(0, 5),
      isRead: reminder.isRead,
      userId: reminder.userId,
      userType: reminder.userType,
    });
    setShowRemindersList(false);
    setShowReminderModal(true);
  };

  const handleReminderInputChange = (field, value) => {
    setReminderData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Check for due reminders
  const checkForDueReminders = useCallback(() => {
    const now = new Date();
    const currentDate = now.toISOString().split("T")[0]; // YYYY-MM-DD
    const currentTime = now.toTimeString().slice(0, 5); // HH:MM

    // Find reminders that are due now and not yet read
    const dueReminders = reminders.filter((reminder) => {
      if (reminder.isRead) return false;

      const reminderDate = new Date(reminder.date);
      const reminderDateStr = reminderDate.toISOString().split("T")[0];
      const reminderTimeStr =
        reminder.time.slice(0, 5) || reminderDate.toTimeString().slice(0, 5);

      return reminderDateStr === currentDate && reminderTimeStr === currentTime;
    });

    // Show popup for the first due reminder
    if (dueReminders.length > 0 && !showReminderPopup) {
      setActiveReminder(dueReminders[0]);
      setShowReminderPopup(true);

      // Optional: Play notification sound
      try {
        const audio = new Audio(
          "data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmwlBSaHy/DTeSUFJnvJ8NaFLgQaZrnr4J5HAAmF2e7Admc="
        );
        audio.play().catch((e) => console.log("Audio play failed:", e));
      } catch (e) {
        console.log("Audio not supported");
      }
    }
  }, [reminders, showReminderPopup]);

  // Reminder popup handlers
  const handleReminderPopupClose = () => {
    setShowReminderPopup(false);
    setActiveReminder(null);
  };

  const handleSnoozeFromPopup = (minutes = 10) => {
    if (activeReminder) {
      snoozeReminder(activeReminder.id, minutes);
      handleReminderPopupClose();
    }
  };

  const handleMarkDoneFromPopup = () => {
    if (activeReminder) {
      markReminderAsRead(activeReminder.id);
      handleReminderPopupClose();
    }
  };

  // Fetch notifications
  const fetchNotifications = useCallback(async () => {
    try {
      const response = await get(`/Notifications/alluser/${userInfo.userId}`);
      console.log("Notifications:", response);
      if (response && response) {
        setNotifications(response);
        // Count unread notifications
        const unreadCount = response.filter(
          (notification) => !notification.isRead
        ).length;
        setNotificationCount(unreadCount);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  }, [userInfo.userId]);

  useEffect(() => {
    if (userInfo?.userId) {
      fetchNotifications();
      fetchReminders();
    }
  }, [userInfo?.userId, fetchNotifications, fetchReminders]);

  // Set up interval to check for due reminders every minute
  useEffect(() => {
    const interval = setInterval(() => {
      checkForDueReminders();
      console.log("Checking for due reminders...");
    }, 2000); // Check every 2 seconds

    // Also check immediately when reminders change
    checkForDueReminders();

    return () => clearInterval(interval);
  }, [checkForDueReminders]);

  // useEffect(() => {
  //   !imgHasError && setUserPix(formatFileUrl(details.userProfilePicture));
  // }, [imgHasError, details]);

  const handleImgError = () => {
    setUserPix("");
    setImgHasError(true);
  };

  return (
    <header>
      <div className="content header-content space-between flex-v-center">
        <div className="header-left">
          {/* <HeaderSearch placeholder="Search transactions or invoices" /> */}
        </div>
        <div className="header-right flex flex-v-center">
          <div className="right-item notification flex p-r">
            <MdNotifications
              onClick={handleNotificationClick}
              style={{ cursor: "pointer" }}
            />
            {notificationCount > 0 && (
              <span
                className="indicator"
                style={{
                  position: "absolute",
                  top: "2px",
                  right: "0px",
                  background: "#ff4444",
                  color: "white",
                  borderRadius: "20%",
                  minWidth: "18px",
                  height: "18px",
                  fontSize: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold",
                  padding: "4px",
                }}
              >
                {notificationCount > 99 ? "99+" : notificationCount}
              </span>
            )}
          </div>
          <div className="right-item">
            <ul className="nav-menu">
              {navList &&
                navList.map((item) => (
                  <li
                    key={item}
                    onClick={() => handleNavItemClick(item)}
                    style={{ cursor: "pointer" }}
                  >
                    {item}
                  </li>
                ))}
            </ul>
          </div>
          <div className="right-item">
            <div
              onClick={handleProfileOpen}
              role="presentation"
              style={{ cursor: "pointer" }}
              className="user-avater-details flex flex-v-center pointer"
            >
              <div className="m-r-5 right-text" style={{ paddingTop: "3px" }}>
                <p className="name">
                  {userInfo.firstName} {userInfo.lastName}
                </p>
                <p className="role">
                  {localStorage.getItem("role") || "Officer 1"}
                </p>
              </div>
              <div className="flex">
                <img
                  onError={handleImgError}
                  src={userInfo?.profilePicture || UserAvater}
                  alt="user avater"
                />
              </div>
              <div className="flex arrow">
                <TiArrowSortedDown />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Notifications Menu */}
      <Menu
        anchorEl={notificationMenuAnchor}
        open={Boolean(notificationMenuAnchor)}
        onClose={handleNotificationClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          style: {
            maxHeight: "400px",
            width: "350px",
            maxWidth: "90vw",
          },
        }}
      >
        {notifications.length > 0 ? (
          notifications.map((notification, index) => (
            <MenuItem
              key={notification.id || index}
              onClick={() => handleNotificationItemClick(notification)}
              style={{
                padding: "12px 16px",
                borderBottom:
                  index < notifications.length - 1
                    ? "1px solid #f0f0f0"
                    : "none",
                backgroundColor: notification.isRead ? "#f9f9f9" : "#fff",
                whiteSpace: "normal",
                alignItems: "flex-start",
                flexDirection: "column",
                minHeight: "auto",
              }}
            >
              <div style={{ width: "100%" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    marginBottom: "4px",
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    style={{
                      fontWeight: notification.isRead ? "normal" : "bold",
                      color: "#1976d2",
                      fontSize: "0.875rem",
                      lineHeight: "1.2",
                      flex: 1,
                      marginRight: "8px",
                    }}
                  >
                    {notification.title || "Notification"}
                  </Typography>
                  {!notification.isRead && (
                    <div
                      style={{
                        width: "8px",
                        height: "8px",
                        backgroundColor: "#ff4444",
                        borderRadius: "50%",
                        flexShrink: 0,
                        marginTop: "2px",
                      }}
                    />
                  )}
                </div>

                <Typography
                  variant="body2"
                  style={{
                    color: "#666",
                    fontSize: "0.8rem",
                    lineHeight: "1.3",
                    marginBottom: "6px",
                    wordBreak: "break-word",
                  }}
                >
                  {notification.message}
                </Typography>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: "6px",
                  }}
                >
                  <Typography
                    variant="caption"
                    style={{
                      color: "#999",
                      fontSize: "0.7rem",
                      backgroundColor: notification.type
                        ? "#e3f2fd"
                        : "transparent",
                      padding: notification.type ? "2px 6px" : "0",
                      borderRadius: notification.type ? "4px" : "0",
                      border: notification.type ? "1px solid #bbdefb" : "none",
                    }}
                  >
                    {notification.type || "General"}
                  </Typography>

                  <Typography
                    variant="caption"
                    style={{
                      color: "#999",
                      fontSize: "0.7rem",
                    }}
                  >
                    {notification.createdAt
                      ? new Date(notification.createdAt).toLocaleDateString(
                          "en-US",
                          {
                            month: "short",
                            day: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                          }
                        )
                      : "Now"}
                  </Typography>
                </div>
              </div>
            </MenuItem>
          ))
        ) : (
          <MenuItem
            onClick={handleNotificationClose}
            style={{
              padding: "20px",
              textAlign: "center",
              justifyContent: "center",
            }}
          >
            <div style={{ textAlign: "center" }}>
              <Typography
                variant="body2"
                color="textSecondary"
                style={{ marginBottom: "4px" }}
              >
                🔔 No notifications
              </Typography>
              <Typography variant="caption" color="textSecondary">
                You're all caught up!
              </Typography>
            </div>
          </MenuItem>
        )}
      </Menu>

      {/* Reminders List Modal */}
      <Dialog
        open={showRemindersList}
        onClose={handleRemindersListClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span>My Reminders</span>
            <Button
              variant="contained"
              color="primary"
              onClick={handleCreateNewReminder}
              style={{ minWidth: "auto" }}
            >
              Add New
            </Button>
          </div>
        </DialogTitle>
        <DialogContent>
          {reminders.length > 0 ? (
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              {reminders.map((reminder, index) => (
                <div
                  key={reminder.id || index}
                  style={{
                    border: "1px solid #e0e0e0",
                    borderRadius: "8px",
                    padding: "16px",
                    marginBottom: "12px",
                    backgroundColor: reminder.isRead ? "#f5f5f5" : "#fff",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <Typography
                        variant="h6"
                        style={{ marginBottom: "8px", fontSize: "1rem" }}
                      >
                        {reminder.message}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        📅 {new Date(reminder.date).toLocaleDateString()} at{" "}
                        {reminder.time ||
                          new Date(reminder.date).toLocaleTimeString()}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        style={{ marginTop: "4px" }}
                      >
                        Status:{" "}
                        {reminder.isRead ? "✅ Completed" : "⏰ Pending"}
                      </Typography>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                        marginLeft: "16px",
                      }}
                    >
                      <Button
                        size="small"
                        variant="outlined"
                        color="primary"
                        onClick={() => editReminder(reminder)}
                      >
                        Update
                      </Button>
                      <Button
                        size="small"
                        variant="outlined"
                        color="secondary"
                        onClick={() => deleteReminder(reminder.id)}
                      >
                        Delete
                      </Button>
                      {!reminder.isRead && (
                        <>
                          <Button
                            size="small"
                            variant="outlined"
                            color="warning"
                            onClick={() => snoozeReminder(reminder.id, 10)}
                            style={{ fontSize: "0.75rem" }}
                          >
                            Snooze 10m
                          </Button>
                          <Button
                            size="small"
                            variant="outlined"
                            color="success"
                            onClick={() => markReminderAsRead(reminder.id)}
                            style={{ fontSize: "0.75rem" }}
                          >
                            Mark Done
                          </Button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div style={{ textAlign: "center", padding: "40px 0" }}>
              <Typography variant="body1" color="textSecondary">
                No reminders found. Click "Add New" to create your first
                reminder!
              </Typography>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleRemindersListClose} color="secondary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Reminder Modal */}
      <Dialog
        open={showReminderModal}
        onClose={handleReminderClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          {editingReminder ? "Edit Reminder" : "Set Reminder"}
        </DialogTitle>
        <DialogContent>
          <TextField
            label="Date"
            type="date"
            value={reminderData.date}
            onChange={(e) => handleReminderInputChange("date", e.target.value)}
            fullWidth
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            label="Time"
            type="time"
            value={reminderData.time}
            onChange={(e) => handleReminderInputChange("time", e.target.value)}
            fullWidth
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            label="Message"
            multiline
            rows={4}
            value={reminderData.message}
            onChange={(e) =>
              handleReminderInputChange("message", e.target.value)
            }
            fullWidth
            margin="normal"
            placeholder="Enter reminder message..."
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleReminderClose} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={handleReminderSubmit}
            color="primary"
            variant="contained"
            disabled={
              !reminderData.date || !reminderData.time || !reminderData.message
            }
          >
            {editingReminder ? "Update Reminder" : "Set Reminder"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Reminder Popup/Alert */}
      <Dialog
        open={showReminderPopup}
        onClose={handleReminderPopupClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: {
            backgroundColor: "#fff3cd",
            border: "2px solid #ffc107",
            borderRadius: "12px",
            boxShadow: "0 8px 32px rgba(255, 193, 7, 0.3)",
          },
        }}
      >
        <DialogTitle
          style={{
            backgroundColor: "#ffc107",
            color: "#212529",
            textAlign: "center",
            fontWeight: "bold",
            padding: "16px",
          }}
        >
          🔔 Reminder Alert!
        </DialogTitle>
        <DialogContent style={{ padding: "24px", textAlign: "center" }}>
          {activeReminder && (
            <>
              <Typography
                variant="h6"
                style={{ marginBottom: "16px", color: "#495057" }}
              >
                {activeReminder.message}
              </Typography>
              <Typography
                variant="body1"
                style={{ marginBottom: "16px", color: "#6c757d" }}
              >
                📅 Scheduled for:{" "}
                {new Date(activeReminder.date).toLocaleDateString()} at{" "}
                {activeReminder.time}
              </Typography>
              <Typography variant="body2" style={{ color: "#6c757d" }}>
                What would you like to do with this reminder?
              </Typography>
            </>
          )}
        </DialogContent>
        <DialogActions
          style={{ justifyContent: "center", padding: "16px 24px 24px" }}
        >
          <Button
            onClick={() => handleSnoozeFromPopup(5)}
            variant="outlined"
            style={{
              borderColor: "#ffc107",
              color: "#ffc107",
              marginRight: "8px",
            }}
          >
            Snooze 5m
          </Button>
          <Button
            onClick={() => handleSnoozeFromPopup(10)}
            variant="outlined"
            style={{
              borderColor: "#ffc107",
              color: "#ffc107",
              marginRight: "8px",
            }}
          >
            Snooze 10m
          </Button>
          <Button
            onClick={handleMarkDoneFromPopup}
            variant="contained"
            style={{
              backgroundColor: "#28a745",
              color: "white",
              marginRight: "8px",
            }}
          >
            Mark Done
          </Button>
          <Button
            onClick={handleReminderPopupClose}
            variant="outlined"
            color="secondary"
          >
            Dismiss
          </Button>
        </DialogActions>
      </Dialog>

      <ProfileModal
        visible={showProfile}
        onClose={handleProfileClose}
        userInfo={userInfo}
      />
    </header>
  );
};

const ProfileModal = ({ visible, onClose, userInfo }) => (
  <div className={`profile-modal ${visible ? "show" : ""}`}>
    <div className="profile-modal-content">
      <button
        className="close-btn"
        style={{ backgroundColor: "red", border: "none", cursor: "pointer" }}
        onClick={onClose}
      >
        ×
      </button>
      <ProfilePage userInfo={userInfo} />
      {/* Add more profile details here */}
    </div>
  </div>
);
export default Header;
